export default function (http) {
    return {


        /*************************产品管理接口开始***********************/

        queryByPage (data){
            return http.json({
                url: '/order/item/query',
                data
            });
        },
        getInfo (data){
            return http.json({
                url: `/order/item/get?id=${data.id}`,
                data
            })
        },
        queryAll (data){
            return http.json({
                url: '/order/item/queryAll',
                data
            })
        },
        saveInfo (data){
            return http.json({
                url: `/order/item/saveBatch`,
                data
            })
        },
        delete (data){
            return http.json({
                url: `/order/item/delete`,
                data
            })
        },
        /** ***********************产品管理接口结束***********************/







    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/orderItem.js